export type ProductState = {
  options: string[];
  selectedVariant: object;
  variants: object[];
};

export type VariantMetafields = {
  [id: string | number]: {
    badge?: {
      text?: string;
      sale?: string;
    };
    waitlist?: {
      disable?: boolean;
    };
    accentuate?: {
      pdp_shipping_note: string;
    };
  };
};

export type TablescapeState = {
  product?: ProductState;
  variantMetafields?: VariantMetafields;
};

const state: TablescapeState = {
  product: {
    variants: [],
    selectedVariant: {},
    options: [],
  },
  variantMetafields: {},
};

export function getTablescapeState(shouldHydrate: boolean = false) {
  const currentState = { ...state };

  if (shouldHydrate) {
    try {
      const variantMetafieldsJSON =
        document.getElementById("variant-metafields");
      const variantMetafieldsData = variantMetafieldsJSON
        ? JSON.parse(variantMetafieldsJSON.textContent)
        : {};
      currentState.variantMetafields = variantMetafieldsData;
    } catch (e) {
      console.error(e);
    }
  }

  return currentState;
}
